import React, { useEffect, useMemo, useRef, useState } from "react";
import { DataSet, Network } from "vis-network/standalone";
import NetworkNodeModal from "../../HighCharts/NetworkNodeModal";
import isEqual from "react-fast-compare";
import "./NetworkGraphV2.scss";
import { Button } from "antd";
// import ArrowDown from "../../../../../assets/NetworkGraph/Arrow_Down.svg";
// import ArrowLeft from "../../../../../assets/NetworkGraph/Arrow_Left.svg";
// import ArrowRight from "../../../../../assets/NetworkGraph/Arrow_Right.svg";
// import Arrow_Up from "../../../../../assets/NetworkGraph/Arrow_Up.svg";
// import Image from "antd/lib/image";
// import fullScreen from "../../../../../assets/NetworkGraph/Screen_Full.png";
import ArrowDown from "../../../../../assets/NetworkGraph/Navigation/NavigationDownWhiteBackground.svg";
import ArrowDownDark from "../../../../../assets/NetworkGraph/Navigation/NavigationDownDarkBackground.svg";
import ArrowLeft from "../../../../../assets/NetworkGraph/Navigation/NavigationLeftWhiteBackground.svg";
import ArrowLeftDark from "../../../../../assets/NetworkGraph/Navigation/NavigationLeftDarkBackground.svg";
import ArrowRight from "../../../../../assets/NetworkGraph/Navigation/NavigationRightWhiteBackground.svg";
import ArrowRightDark from "../../../../../assets/NetworkGraph/Navigation/NavigationRightDarkBackground.svg";
import ArrowUp from "../../../../../assets/NetworkGraph/Navigation/NavigationUpWhiteBackground.svg";
import ArrowUpDark from "../../../../../assets/NetworkGraph/Navigation/NavigationUpDarkBackground.svg";
import FullScreen from "../../../../../assets/NetworkGraph/Navigation/FullScreenDarkBackground.svg";
import FullScreenDark from "../../../../../assets/NetworkGraph/Navigation/FullScreenDarkBackground.svg";
import ZoomIn from "../../../../../assets/NetworkGraph/Navigation/ZoomInWhiteBackground.svg";
import ZoomInDark from "../../../../../assets/NetworkGraph/Navigation/ZoomInDarkBackground.svg";
import ZoomOut from "../../../../../assets/NetworkGraph/Navigation/ZoomOutWhiteBackground.svg";
import ZoomOutDark from "../../../../../assets/NetworkGraph/Navigation/ZoomOutDarkBackground.svg";
import ResetZoom from "../../../../../assets/NetworkGraph/Navigation/ResetZoomWhiteBackground.svg";
import ResetZoomDark from "../../../../../assets/NetworkGraph/Navigation/ResetZoomDarkBackground.svg";
import RefershIcon from "../../../../../assets/NetworkGraph/Navigation/RefreshZoomWhiteBackground.svg";
import RefershIconDark from "../../../../../assets/NetworkGraph/Navigation/RefreshZoomDarkBackground.svg";
import GenerateStatus from "./GenerateStatus";
import NetworkNodeTooltip from "./NetworkNodeTooltip";
import NetworkDeepdive from "./NetworkDeepdive";
import { useSelector } from "react-redux";
import { callNotification } from "../../../../../redux/constants";
const NetworkGraphV2 = ({
  nodes,
  edges,
  options,
  id,
  style,
  single,
  section_index,
  widget_index,
  metadata,
  PdfDownloadStatus,
  type,
  isNetworkDeepDive,
}) => {
  const containerRef = useRef(null);
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const [dataProcessing, setDataProcessing] = useState(true);
  const [processNextDataLoad, setProcessNextDataLoad] = useState(false);
  const [postCardDetails, setPostCardDetails] = useState(null);
  const [networkDeepDiveObj, setNetworkDeepDiveObj] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNetworkModalOpen, setIsNetworkModalOpen] = useState(false);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const [screenLoader, setScreenLoader] = useState(true);
  const [network, setNetwork] = useState(null);
  const [renderedNodes, setRenderedNodes] = useState([]);
  const [renderedEdges, setRenderedEdges] = useState([]);
  const [
    stabilizeNetworkAfterAllNodesRenders,
    setStabilizeNetworkAfterAllNodesRenders,
  ] = useState(false);
  const [waitForInitialRender, setWaitForInitialRender] = useState(true);
  const [showHideNodeImage, setShowHideNodeImage] = useState(false);
  const [addDataInIntervalHandler, setAddDataInIntervalHandler] = useState();
  const [tooltipObject, setTooltipObject] = useState(null);
  const [movementInterval, setMovementInterval] = useState(null);
  const [direction, setDirection] = useState(null);
  const NEXT_DATA_SET = 200;
  const NEXT_DATA_LOAD_INTERVAL = 5000;
  const removeDuplicateNodes = (nodes) => {
    const nodeMap = new Map();
    if (nodes && Array.isArray(nodes)) {
      nodes?.forEach((node) => {
        if (!nodeMap.has(node?.id)) {
          nodeMap.set(node?.id, node);
        }
      });
    }

    return Array.from(nodeMap?.values());
  };
  const getNodeOfNetwork = (seriesData, nodeId) => {
    let node;
    let splittedValue = nodeId?.split("$N$");
    if (seriesData && Array.isArray(seriesData)) {
      for (
        let series_index = 0;
        series_index < seriesData?.length;
        series_index++
      ) {
        let series = seriesData?.[series_index];
        if (
          splittedValue?.[0] === id &&
          (splittedValue?.[1] === series?.cluster_id ||
            parseInt(splittedValue?.[1]) === series_index)
        ) {
          if (series?.nodes?.[splittedValue?.[2]]) {
            node = series?.nodes?.[splittedValue?.[2]];
            break;
          }
        }
      }
    } else if (seriesData && seriesData?.nodes) {
      if (seriesData?.nodes?.[splittedValue?.[2]]) {
        node = seriesData?.nodes?.[splittedValue?.[2]];
      }
    }
    return node;
  };
  const getNodeDataForRendering = (rNodes) => {
    let updatedNodes = [];
    if (showHideNodeImage) {
      const originalNodes = Array.isArray(rNodes) ? rNodes : [];
      updatedNodes = Array.isArray(originalNodes)
        ? originalNodes?.map((n) => {
            return {
              ...n,
              image: n?.image ? n?.image : undefined,
              shape: n?.image ? "circularImage" : "dot",
              size: n?.image
                ? n?.size > 100
                  ? 100
                  : n?.size < 20
                  ? 20
                  : parseInt(n?.size)
                : 20,
            };
          })
        : [];
    } else {
      const originalNodes = Array.isArray(rNodes) ? rNodes : [];
      updatedNodes = Array.isArray(originalNodes)
        ? originalNodes?.map((n) => {
            return {
              ...n,
              image: undefined,
              shape: "dot",
              radius:
                n?.size > 100 ? 100 : n?.size < 20 ? 20 : parseInt(n?.size),
            };
          })
        : [];
    }
    const uniqueNodes =
      updatedNodes?.length > 0 ? removeDuplicateNodes(updatedNodes) : [];
    return uniqueNodes;
  };
  const isPersonalizationPreviewOpen = useMemo(() => {
    return personalizationSettingsObj?.isPersonalizationPreviewOpen
      ? true
      : false;
  }, [personalizationSettingsObj?.isPersonalizationPreviewOpen]);
  useEffect(() => {
    const container = document.getElementById(id);
    let renderedNodes = [],
      renderedEdges = [];
    if (nodes && Array.isArray(nodes) && nodes?.length > NEXT_DATA_SET) {
      renderedNodes = nodes?.slice(0, NEXT_DATA_SET);
      renderedNodes = getNodeDataForRendering(renderedNodes);
      renderedNodes = new DataSet(renderedNodes);
      setRenderedNodes(renderedNodes);
    } else {
      renderedNodes = getNodeDataForRendering(nodes);
      renderedNodes = new DataSet(renderedNodes);
      setRenderedNodes(renderedNodes);
    }

    if (edges && Array.isArray(edges) && edges?.length > NEXT_DATA_SET) {
      renderedEdges = new DataSet(edges?.slice(0, NEXT_DATA_SET));
      setRenderedEdges(renderedEdges);
    } else {
      renderedEdges = new DataSet(edges);
      setRenderedEdges(renderedEdges);
    }
    setProcessNextDataLoad(false);
    setWaitForInitialRender(true);
    setStabilizeNetworkAfterAllNodesRenders(false);
    setScreenLoader(true);
    const data = {
      nodes: renderedNodes,
      edges: renderedEdges,
    };

    const network = new Network(container, data, options);
    setNetwork(network);
    // on init
    network?.on("initRedraw", function () {
      // do something like move some custom elements?
      setDataProcessing(true);
    });

    // Add event listener to show tooltip on hover
    network?.on("hoverNode", (params) => {
      const nodeId = params?.node;
      const node =
        nodes && Array.isArray(nodes) && nodes?.find((f) => f?.id === nodeId);
      if (node) {
        setTooltipObject({
          node: node,
          clientX: parseInt(params?.event?.clientX),
          clientY: parseInt(params?.event?.clientY),

          canvasX: parseInt(params?.pointer?.canvas?.x),
          canvasY: parseInt(params?.pointer?.canvas?.y),
          domX: parseInt(params?.pointer?.DOM?.x),
          domY: parseInt(params?.pointer?.DOM?.y),
        });
      }
    });

    // Add event listener to hide tooltip on mouseout

    network?.on("blurNode", () => {
      // console.log(
      //   "\n\n\n ****************** blurNode event got called : **************************\n\n\n"
      // );
      setTooltipObject(null);
    });

    network?.on("stabilized", () => {
      // console.log(
      //   "\n\n\n ****************** stabilized event got called : **************************\n\n\n"
      // );
      setWaitForInitialRender(false);
      // if (
      //   renderedNodes?.length !== nodes?.length ||
      //   renderedEdges?.length !== edges?.length
      // ) {
      //   // setProcessNextDataLoad(true);
      // } else {
      //   console.log(
      //     "\n\n\n\n****************** All node rendered ************************",
      //     stabilizeNetworkAfterAllNodesRenders
      //   );
      // }
    });
    network?.on("afterDrawing", function (ctx) {
      setDataProcessing(false);
      setScreenLoader(false);
    });

    //
    network?.on("click", function (params) {});
    network?.on("doubleClick", function (params) {
      if (isPersonalizationPreviewOpen) {
        callNotification(
          "Actions are not allowed while customizing",
          "info",
          40,
          "personalization-preview-notification personalization-preview-mask",
          true
        );
        return;
      }
      if (params?.nodes?.length > 0 && !isNetworkDeepDive) {
        let nodeId = params?.nodes[0];
        const node = getNodeOfNetwork(single, nodeId);
        if (node) {
          setPostCardDetails(node);
          setNetworkDeepDiveObj(node);
        }
      }
    });
    network?.on("zoom", (params) => {
      const zoomLevel = parseFloat(params?.scale)?.toFixed(1);
      setShowHideNodeImage(zoomLevel >= 0.5);
    });

    // Clean up when component unmounts
    return () => {
      if (network) {
        network?.destroy();
        network?.off("hoverNode");
        network?.off("blurNode");
        network?.off("stabilized");
        network?.off("initRedraw");
        network?.off("afterDrawing");
        network?.off("click");
        network?.off("doubleClick");
        network?.off("zoom");
      }
    };
  }, [nodes, edges, options, isPersonalizationPreviewOpen]);
  const handleFullScreen = () => {
    const container = containerRef?.current;
    if (container?.requestFullscreen) {
      container?.requestFullscreen();
    } else if (container?.mozRequestFullScreen) {
      container?.mozRequestFullScreen();
    } else if (container?.webkitRequestFullscreen) {
      container?.webkitRequestFullscreen();
    } else if (container?.msRequestFullscreen) {
      container?.msRequestFullscreen();
    }
  };

  useEffect(() => {
    if (
      renderedNodes?.length === nodes?.length &&
      renderedEdges?.length === edges?.length &&
      !stabilizeNetworkAfterAllNodesRenders
    ) {
      setStabilizeNetworkAfterAllNodesRenders(true);
      // network && network?.stabilize();
    }
  }, [
    stabilizeNetworkAfterAllNodesRenders,
    renderedNodes?.length,
    renderedEdges?.length,
  ]);
  useEffect(() => {
    // console.log(
    //   "\n\n\n ******************* useEffect got called ********************* \n\n"
    // );
    // console.log("processNextDataLoad : ", processNextDataLoad);
    let nextDataProcessHandler;
    if (!waitForInitialRender) {
      nextDataProcessHandler = setTimeout(() => {
        if (processNextDataLoad) {
          loadMoreNetworkData();
        } else {
          setProcessNextDataLoad(true);
        }
      }, [processNextDataLoad ? 100 : NEXT_DATA_LOAD_INTERVAL]);
    }

    return () => clearTimeout(nextDataProcessHandler);
  }, [processNextDataLoad, waitForInitialRender]);
  useEffect(() => {
    // if it is true that means show images
    if (showHideNodeImage) {
      const rNodes =
        typeof renderedNodes?.get === "function" && renderedNodes?.get();
      const originalNodes = Array.isArray(rNodes)
        ? nodes?.slice(0, rNodes?.length)
        : [];
      let updatedNodes = getNodeDataForRendering(originalNodes);
      if (typeof renderedNodes?.update === "function") {
        renderedNodes?.update([...updatedNodes]);
        // network?.destroy();
        if (network && typeof network?.redraw === "function") {
          network?.redraw();
        }
      }
    } else {
      const rNodes =
        typeof renderedNodes?.get === "function" && renderedNodes?.get();
      const originalNodes = Array.isArray(rNodes)
        ? nodes?.slice(0, rNodes?.length)
        : [];
      let updatedNodes = getNodeDataForRendering(originalNodes);
      if (typeof renderedNodes?.update === "function") {
        renderedNodes?.update([...updatedNodes]);
        // network?.destroy();
        if (network && typeof network?.redraw === "function") {
          network?.redraw();
        }
      }
    }
  }, [showHideNodeImage]);
  const loadMoreNetworkData = () => {
    // console.log(
    //   "loadMoreNetworkData got called ",
    //   "nodes length : ",
    //   nodes?.length,
    //   "edges?.length : ",
    //   edges?.length,
    //   "current node length : ",
    //   renderedNodes?.length,
    //   "current edges length : ",
    //   renderedEdges?.length
    // );
    let newNodes = [],
      newEdges = [];
    if (renderedNodes?.length !== nodes?.length) {
      newNodes = nodes?.slice(
        renderedNodes?.length,
        renderedNodes?.length + NEXT_DATA_SET
      );
      newNodes = getNodeDataForRendering(newNodes);
    }
    if (renderedEdges?.length !== edges?.length) {
      newEdges = edges?.slice(
        renderedEdges?.length,
        renderedEdges?.length + NEXT_DATA_SET
      );
    }
    if (newNodes?.length > 0) {
      // renderedNodes?.add(newNodes);
      renderedNodes?.update([...renderedNodes?.get(), ...newNodes]);
      // setRenderedNodes([...renderedNodes?.get(), ...newNodes]);
      // network?.body?.data?.nodes?.add([...renderedNodes?.get(), ...newNodes]);
    }
    if (newEdges?.length > 0) {
      // renderedEdges?.add(newEdges);
      renderedEdges?.update([...renderedEdges?.get(), ...newEdges]);
      // setRenderedEdges([...renderedEdges?.get(), ...newEdges]);
      // network?.body?.data?.edges?.add(newEdges);
    }
    if (newNodes?.length > 0 || newEdges?.length > 0) {
      // network?.stabilize();
      setProcessNextDataLoad(false);
    }

    // const worker = new Worker(new URL("./networkWorker.js", import.meta.url));
    // worker?.postMessage({
    //   type: "LOAD_MORE_NETWORK_NODES",
    //   currentNodeCount: nodes.length,
    //   additionalNodes: 100,
    //   additionalEdges: 50,
    // });
  };
  // const handleLoadMore = () => {
  //   const worker = new Worker(new URL("./networkWorker.js", import.meta.url));
  //   worker.postMessage({
  //     type: "LOAD_MORE_NODES",
  //     currentNodeCount: nodes.length,
  //     additionalNodes: 100,
  //     additionalEdges: 50,
  //   });

  //   worker.onmessage = function (event) {
  //     const newNodes = event.data.nodes;
  //     const newEdges = event.data.edges;

  //     network.body.data.nodes.add(newNodes);
  //     network.body.data.edges.add(newEdges);
  //     network.stabilize();
  //   };
  // };
  // useEffect(() => {
  //   console.log(
  //     "tooltipObject : ",
  //     tooltipObject,
  //     "networkDeepDiveObj : ",
  //     networkDeepDiveObj
  //   );
  // }, [tooltipObject, networkDeepDiveObj]);
  const moveNetwork = (direction) => {
    const moveStep = 1000; // Adjust the value for speed of movement
    let moveBy = { x: 0, y: 0 };
    let scaleBy = 1;
    switch (direction) {
      case "zoomIn":
        scaleBy = 1.2;
        break;
      case "zoomOut":
        scaleBy = 0.8;
        break;
      case "down":
        moveBy = { x: 0, y: moveStep };
        break;
      case "up":
        moveBy = { x: 0, y: -moveStep };
        break;
      case "right":
        moveBy = { x: moveStep, y: 0 };
        break;
      case "left":
        moveBy = { x: -moveStep, y: 0 };
        break;

      default:
        break;
    }
    try {
      if (direction === "resetZoom") {
        if (network && typeof network?.fit === "function") {
          network?.fit({
            animation: {
              duration: 200,
              easingFunction: "linear",
            },
          });
        }
      } else if (
        network &&
        typeof network?.moveTo === "function" &&
        typeof network?.getViewPosition === "function" &&
        typeof network?.getScale === "function"
      ) {
        const currentPosition = network?.getViewPosition();
        network?.moveTo({
          scale: network?.getScale() * scaleBy,
          position: {
            x: currentPosition.x + moveBy.x,
            y: currentPosition.y + moveBy.y,
          },
          animation: {
            duration: 200,
            easingFunction: "linear",
          },
        });
      }
    } catch (error) {
      console.error("Error on move chart : ", error);
    }
  };
  const handleMovementStart = (direction) => {
    setDirection(direction);
    moveNetwork(direction);
    if (movementInterval) clearInterval(movementInterval);
    const interval = setInterval(() => moveNetwork(direction), 100);
    setMovementInterval(interval);
  };
  const handleMovementStop = () => {
    setDirection(null);
    if (movementInterval) clearInterval(movementInterval);
  };
  return (
    <>
      <div className="NetworkGraphContainer" style={{ display: "flex" }}>
        {screenLoader ? (
          <div className="Network__Graph w-100 h-100">
            <div
              id={id}
              style={{
                width: style?.width ? style?.width : "100%",
                height: style?.height
                  ? style?.height?.includes("%")
                    ? style?.height
                    : style?.height?.includes("px")
                    ? style?.height
                    : style?.height + "px"
                  : "45rem",
              }}
            ></div>
            <div
              style={{
                marginTop: style?.height
                  ? style?.height?.includes("px")
                    ? style?.height
                    : -style?.height + "px"
                  : "-45rem",
                height: style?.height
                  ? style?.height?.includes("px")
                    ? style?.height
                    : style?.height + "px"
                  : "45rem",
              }}
            >
              <div className="loader text-center w-100 h-100">
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="Network__Graph w-100 h-100">
              <div
                id={id}
                ref={containerRef}
                style={{
                  width: style?.width ? style?.width : "100%",
                  height: style?.height
                    ? style?.height?.includes("px")
                      ? style?.height
                      : style?.height + "px"
                    : "45rem",
                }}
              ></div>
              {!stabilizeNetworkAfterAllNodesRenders ? (
                <GenerateStatus></GenerateStatus>
              ) : (
                ""
              )}
              {/* <Button
            onClick={handleFullScreen}
            className="fullScreen--btn btn_Clear m-1"
          >
            Full Screen
          </Button> */}
              {/* {postCardDetails && (
            <>
              <NetworkNodeModal
                modalData={postCardDetails}
                isModalOpen={postCardDetails ? true : false}
                setIsModalOpen={setIsModalOpen}
                setIsModalData={setPostCardDetails}
                isVisNetworkGraph={true}
                isModalLoader={isModalLoader}
                setIsModalLoader={setIsModalLoader}
              />
            </>
          )} */}
              {networkDeepDiveObj ? (
                <>
                  <NetworkDeepdive
                    networkDeepDiveObj={networkDeepDiveObj}
                    isNetworkModalOpen={networkDeepDiveObj ? true : false}
                    setIsNetworkModalOpen={setIsNetworkModalOpen}
                    setNetworkDeepDiveObj={setNetworkDeepDiveObj}
                    isVisNetworkGraph={true}
                    isModalLoader={isModalLoader}
                    setIsModalLoader={setIsModalLoader}
                    section_index={section_index}
                    widget_index={widget_index}
                    metadata={metadata}
                    style={style}
                    id={id}
                    PdfDownloadStatus={PdfDownloadStatus}
                    type={type}
                  />
                </>
              ) : (
                ""
              )}
              {tooltipObject ? (
                <NetworkNodeTooltip
                  tooltipData={tooltipObject}
                  isTooltipShow={tooltipObject === null ? false : true}
                  containerRef={containerRef}
                />
              ) : (
                ""
              )}

              {/* <div
            className={`wordcloud_card ${
              tooltipObject === null ? "d-none" : ""
            }`}
            style={{
              left: tooltipObject?.clientX,
              top: tooltipObject?.clientY,
              width: "20rem",
              height: "20rem",
              backgroundColor: tooltipObject?.node?.color?.background,
              borderColor: tooltipObject?.node?.color?.color,
            }}
          >
            Tooltip AuthorBio
          </div> */}
            </div>
            {/* Sidebar for custom navigation */}
            <div className="Network__Sidebar border-color border-top">
              {/* <img
                className={`Network__Sidebar--btn ${
                  direction === "reset" ? "active" : ""
                }`}
                src={
                  authParams?.theme_type === "1" ? FullScreen : FullScreenDark
                }
              />
              <span className="Network__Sidebar--sep border-color"></span> */}
              <img
                className={`Network__Sidebar--btn ${
                  direction === "resetZoom" ? "active" : ""
                }`}
                src={authParams?.theme_type === "1" ? ResetZoomDark : ResetZoom}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("resetZoom")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              />
              <img
                className={`Network__Sidebar--btn ${
                  direction === "zoomIn" ? "active" : ""
                }`}
                src={authParams?.theme_type === "1" ? ZoomInDark : ZoomIn}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("zoomIn")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              />
              <img
                className={`Network__Sidebar--btn ${
                  direction === "zoomOut" ? "active" : ""
                }`}
                src={authParams?.theme_type === "1" ? ZoomOutDark : ZoomOut}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("zoomOut")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              />
              <span className="Network__Sidebar--sep border-color"></span>

              <img
                className={`Network__Sidebar--btn ${
                  direction === "up" ? "active" : ""
                }`}
                src={authParams?.theme_type === "1" ? ArrowUpDark : ArrowUp}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("up")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              />
              <img
                className={`Network__Sidebar--btn ${
                  direction === "left" ? "active" : ""
                }`}
                src={authParams?.theme_type === "1" ? ArrowLeftDark : ArrowLeft}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("left")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              />
              <img
                className={`Network__Sidebar--btn ${
                  direction === "down" ? "active" : ""
                }`}
                src={authParams?.theme_type === "1" ? ArrowDownDark : ArrowDown}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("down")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              />
              <img
                className={`Network__Sidebar--btn ${
                  direction === "right" ? "active" : ""
                }`}
                src={
                  authParams?.theme_type === "1" ? ArrowRightDark : ArrowRight
                }
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("right")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              />
              {/* <span className="Network__Sidebar--sep border-color"></span> */}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default React?.memo(NetworkGraphV2, isEqual);
